import { PageContent } from '@va/dashboard/shared/ui-layout';
import { usePageHeaderProps } from '@va/dashboard/util-hooks';
import { useRefreshContext } from '@va/util/components';
import { useMemo } from 'react';
import { VisitsByCompanyCard } from './VisitsByCompanyCard';

export const VisitsByCompanyOverview = () => {
  const { manualRefresh } = useRefreshContext();

  const pageHeaderProps = useMemo(() => ({ refreshFn: () => manualRefresh() }), [manualRefresh]);

  usePageHeaderProps(pageHeaderProps);

  return (
    <PageContent>
      <VisitsByCompanyCard />
    </PageContent>
  );
};
